import { useTranslation } from 'react-i18next';
import { LuArrowRight } from 'react-icons/lu';

import type { TrialGoalNext } from '~/types/client/trialGoal';

import styles from './TrialGoalCard.module.css';

/**
 * Objectif « 3 soirées pendant l'essai », sur la télécommande de l'animateur :
 * soirée en cours, idée de la soirée et un lien qui met le bon jeu à l'écran.
 * Vu seulement sur le téléphone — jamais sur la TV (vue par les clients du bar).
 * `onAction` absent = pas de lien (jeu absent du catalogue du lieu, ou déjà à l'écran).
 */
export function TrialGoalCard({
    night,
    target,
    next,
    onAction,
    className,
}: {
    night: number;
    target: number;
    next: TrialGoalNext;
    onAction?: () => void;
    className?: string;
}) {
    const { t } = useTranslation();
    return (
        <aside className={`${styles.card} ${className ?? ''}`}>
            <span className={styles.eyebrow}>{t('trialGoal.eyebrow', { night, target })}</span>
            <p className={styles.text}>{t(`trialGoal.text.${next}`)}</p>
            {onAction && (
                <button type="button" className={styles.link} onClick={onAction}>
                    <span>{t(`trialGoal.action.${next}`)}</span>
                    <LuArrowRight aria-hidden="true" />
                </button>
            )}
        </aside>
    );
}
